<template>
  <div
    class="mr-5 p-2 w-32 absolute right-0 rounded-lg bg-white"
    style="z-index:1000"
  >
    <div class="flex flex-col">
      <span class="mb-2 font-semibold">{{ username }}</span>
      <span
        v-for="(item, index) of roles"
        class="my-1 text-gray-500"
        :key="index"
      >{{ item }}</span>
    </div>
    <div
      class="mt-5 flex flex-row justify-center cursor-pointer hover:text-secondary hover:font-semibold"
      @click="logout"
    >
      <vs-icon
        icon="logout"
        size="15px"
        class="self-center mr-1"
      />
      <p class="ml-1">
        Logout
      </p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

import { showFailedNotification } from '@/utils/cosmeticsUtils'

export default {
  props: {
    username: {
      type: String,
      default: () => null
    },
    roles: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      isLoginWithAzure: 'Auth/isLoginWithAzure'
    })
  },
  methods: {
    async logout() {
      try{
        if (this.isLoginWithAzure) {
          await this.$store.dispatch('OidcAuth/signout')
        } else {
          await this.$store.dispatch('Auth/logout')
          this.$router.push({ name: 'Login', replace: true })
        }
      } catch (error) {
        showFailedNotification(this, 'failed to logout, please try again later', 'Failed' )
      }
    }
  }
}
</script>

<style scoped>

</style>
